import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActionModuleEnum, ActionsService } from '@brafton/angular-framework-library';
import { StylesSmartTableComponent } from '@brafton/angular-styles-library';
import { Action, Organization, UserGroup, UserProfile } from '@brafton/common-framework-library';
import { BfAuthService } from '@brafton/skynet-angular-security-service';

@Component({
  selector: 'shared-users-listing',
  templateUrl: './users-listing.component.html',
  styleUrls: ['./users-listing.component.scss'],
  host: { class: 'users-listing' },
})
export class SharedUsersListingComponent implements OnInit {
  @Input() users!: UserProfile[];
  @Input() organization!: Organization;
  @Input() showLastLogin!: boolean;
  @Input() showRole!: boolean;
  @Input() showActions = true;
  @Input() showColumnHeaders = true;
  @Input() showGroups = false;
  @Input() showProfileId = true;

  actions!: Action[];

  @ViewChild('smartTable') smartTable!: StylesSmartTableComponent<any>;

  constructor(private auth: BfAuthService, private actionsService: ActionsService) {}

  ngOnInit(): void {}

  buildMainColumns(): string[] {
    const columns = ['title']; //, 'email'

    if (this.showLastLogin === true) columns.push('lastLogin');
    if (this.showProfileId === true) columns.push('profileId');
    columns.push('state');
    if (this.showRole === true) columns.push('role');
    if (this.showGroups === true) columns.push('groups');
    if (this.showActions === true) columns.push('actions');

    return columns;
  }

  editUserModal(user: any) {
    this.actionsService.changeActions(
      'EditUser',
      ActionModuleEnum.admin,
      this.organization as any,
      user,
      undefined,
      undefined,
      'project',
    );
  }

  removeStandardGroups(user: UserProfile): UserGroup[] {
    const groupsToIgnore = [
      '620adb37a9741a006595a260',
      '620adb32a9741a006595a25f',
      '620adb2ea9741a006595a25e',
      '620adb1da9741a006595a25d',
      '620adb4aa9741a006595a264',
      '620adb45a9741a006595a263',
      '620adb41a9741a006595a262',
      '620adb3ba9741a006595a261',
    ];
    const groups = (user as any).groups?.filter((g: UserGroup) => groupsToIgnore.includes(g.id) === false);

    return groups;
  }

  private createAction(id: string, displayName: string): Action {
    return {
      actionEnum: {
        hidden: false,
        displayName,
        id,
      },
      isEnabled: true,
    } as Action;
  }

  getActionDataDynamic(user: UserProfile): Action[] {
    const actions = {
      resetPassword: this.createAction('ResetPassword', 'Reset Password'),
      editUser: this.createAction('EditUser', 'Edit User'),
      changePicture: this.createAction('EditPicture', 'Edit Picture'),
      changePermissions: this.createAction('EditPermission', 'Edit Permission'),
      copyInviteUrl: this.createAction('CopyInviteURL', 'Copy Invite Url'),
      deleteUser: this.createAction('DeleteUser', 'Delete User'),
    };

    if (user.state === 'Invited') {
      return [actions.copyInviteUrl, actions.deleteUser];
    }

    return [
      actions.resetPassword,
      actions.editUser,
      actions.changePicture,
      actions.changePermissions,
      actions.deleteUser,
    ];
  }
}
